<template>
  <v-container
    id="data-management"
    tag="section"
  >
    <base-resource-grid
      color="grey"
      icon="mdi-sitemap"
      plural-name="Benefit Admin Sites"
      singular-name="Benefit Admin Site"
      allow-expand
      :headers="headers"
      :resource="benefitAdminSiteResource"
      :actions="actions"
      @handleAction="handleAction"
    >
      <template v-slot:editForm="bindings">
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.benefitAdminSite"
              :error-messages="bindings.formErrors.BenefitAdminSite"
              label="Benefit Admin Site"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <base-resource-select
              v-if="bindings && bindings.editedItem"
              label="Platform"
              item-text="platform"
              item-value="id"
              bind-text="platform"
              bind-value="platformId"
              :bind-item="bindings.editedItem"
              :error-messages="bindings.formErrors.PlatformId"
              :resource="platformResource"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.siteUrl"
              :error-messages="bindings.formErrors.SiteUrl"
              label="Site URL"
            />
          </v-col>
        </v-row>
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="benefitAdminSiteHistory/"
      id-field="benefitAdminSiteId"
      title-field="benefitAdminSite"
      color="grey"
      :columns="historyHeaders"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'BenefitAdminSites',

    data: () => ({
      headers: [
        {
          text: 'Benefit Admin Site',
          value: 'benefitAdminSite',
        },
        {
          text: 'Platform',
          value: 'platform',
        },
      ],

      historyHeaders: [
        {
          text: 'Benefit Admin Site',
          value: 'benefitAdminSite',
        },
        {
          text: 'Platform',
          value: 'platform',
        },
        {
          text: 'Site URL',
          value: 'siteUrl',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      benefitAdminSiteResource: new TroodyApi('benefitAdminSite/'),
      platformResource: new TroodyApi('platform/'),

      historyItem: null,
    }),

    methods: {
      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },
    },
  }
</script>
